var r, t;
function s() {
  if (t) return r;
  t = 1;
  return r = class {
    constructor(r, t, s, e) {
      this.statusCode = r, this.payload = t, this.error = s, this.headers = e;
    }
  };
}
export { s as __require };